import { Redirect, Stack } from "expo-router";
import { observer } from "mobx-react";
import { EvidensiaLogo } from "~/assets/logos/EvidensiaLogo";
import { Header } from "~/components/Header";
import { useStore } from "~/mobx/utils/useStore";

const AuthLayout = observer(function AuthLayout() {
  const store = useStore();

  const isLoggedIn = store.authStore.isLoggedIn;

  if (isLoggedIn) {
    return <Redirect href="/(app)" />;
  }

  return (
    <Stack
      initialRouteName="login"
      screenOptions={{
        header: (props) => <Header {...props} />,
        freezeOnBlur: false,
        animation: "slide_from_right",
      }}
    >
      <Stack.Screen
        name="login"
        options={{
          headerShown: false,
          headerTitle: () => <EvidensiaLogo size={85} />,
        }}
      />
    </Stack>
  );
});

export default AuthLayout;
